import React, { createContext, useContext, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { CITIES_DATA } from '../data/citiesData';

const EntryContext = createContext({ entryCity: null });
const SESSION_KEY = 'entryCityData';

export const EntryProvider = ({ children }) => {
    const location = useLocation();

    const getInitialCity = () => {
        const storedData = sessionStorage.getItem(SESSION_KEY);
        try {
            return storedData ? JSON.parse(storedData) : null;
        } catch (e) {
            console.error("Erro ao ler dados da cidade da sessão:", e);
            return null;
        }
    };

    const [entryCity, setEntryCity] = useState(getInitialCity);

    const saveEntryCity = (cityData) => {
        if (!cityData) {
            setEntryCity(null);
            sessionStorage.removeItem(SESSION_KEY);
            return;
        }

        setEntryCity(cityData);
        sessionStorage.setItem(SESSION_KEY, JSON.stringify(cityData));
    };

    useEffect(() => {
        const match = location.pathname.match(/^\/(?:city|conversion)\/([^/]+)/i);
        const cityId = match?.[1]?.toLowerCase() || null;

        if (!cityId) {
            saveEntryCity(null);
            return;
        }

        const nextCity = CITIES_DATA[cityId] || null;
        saveEntryCity(nextCity);
    }, [location.pathname]);

    return (
        <EntryContext.Provider value={{ entryCity, saveEntryCity }}>
            {children}
        </EntryContext.Provider>
    );
};

export const useEntryTracking = () => {
    const context = useContext(EntryContext);
    if (!context) {
        throw new Error('useEntryTracking deve ser usado dentro de um EntryProvider.');
    }
    return context;
};
